import { useEffect, useState } from "react";
import ServesCard from "./FeaturesCard";

// id 2 and id 3 has duplicate content

type Props = {
  result?: Result;
  name?: string;
  agencyList: Agency[];
  baseUrl?: string;
};

const RentalFeatures = ({ result, name, agencyList, baseUrl }: Props) => {
  const [isUserAgentBot, setIsUserAgentBot] = useState(true);
  // const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // setMounted(true);
    if (!/bot/i.test(navigator.userAgent)) setIsUserAgentBot(false);
  }, []);

  const servesData = result
    ? [
        {
          id: 1,
          img: "/serves/serves-4.svg",
          subtitle: "Most Popular Agency",
          title: `${
            agencyList.sort((a, b) => {
              if (a.pickupLocation?.overallScore?.score === undefined) return 1;
              if (b.pickupLocation?.overallScore?.score === undefined)
                return -1;
              return (
                b.pickupLocation?.overallScore?.score -
                a.pickupLocation?.overallScore?.score
              );
            })[0].name
          }`,
          desc: `Based on our data, the most popular Airport car rental in ${name} is ${
            agencyList.sort((a, b) => {
              if (a.pickupLocation?.overallScore?.score === undefined) return 1;
              if (b.pickupLocation?.overallScore?.score === undefined)
                return -1;
              return (
                b.pickupLocation?.overallScore?.score -
                a.pickupLocation?.overallScore?.score
              );
            })[0].name
          }.`,
          // link: `agency/${agencyList
          //   .sort((a, b) => {
          //     if (a.pickupLocation?.overallScore?.score === undefined) return 1;
          //     if (b.pickupLocation?.overallScore?.score === undefined)
          //       return -1;
          //     return (
          //       b.pickupLocation?.overallScore?.score -
          //       a.pickupLocation?.overallScore?.score
          //     );
          //   })[0]
          //   .providerCode.toLowerCase()}`,
        },
        {
          id: 2,
          img: "/serves/serves-3.svg",
          title: `${result?.most_popular_cars[0].car.carclass}`,
          subtitle: `Most Popular Car Type`,
          desc: `With a seating capacity of ${result?.most_popular_cars[0].car.passengers} passengers, ${result?.most_popular_cars[0].car.carclass} cars are the one people renting most in ${name}.`,
          // link: `class/${result?.most_popular_cars[0].car.category.toLowerCase()}`,
        },
        {
          id: 3,
          img: "/serves/serves-2.svg",
          subtitle: "Cheapest Car Model",
          title: `${result?.cheapest_cars[0].car.brand}`,
          desc: `${
            result?.cheapest_cars[0].car.brand
          } has the most discounted Car rental deals in ${name}. This is closely followed by ${
            result?.cheapest_cars[1].car.brand
          }${
            result?.cheapest_cars?.[2]?.car.brand === undefined
              ? ``
              : ` and ${result?.cheapest_cars?.[2]?.car.brand}`
          }.`,
          // link: `car/${result?.cheapest_cars[0].car.brand
          //   .split(" ")[0]
          //   .toLowerCase()}`,
        },
        {
          id: 4,
          img: "/serves/serves-1.svg",
          subtitle: "Lowest Price",
          title: `${result?.cheapest_cars[0].displayTotalPrice ?? `$50`}`,
          desc: `Our deals allow you to Rent a car in ${name} for just ${
            result?.cheapest_cars[0].displayTotalPrice ?? `$50`
          }/ day. Please remember the average rental car cost ${
            result?.recommended_cars?.length > 1
              ? result?.recommended_cars?.slice(0, -1)[0]?.displayTotalPrice ??
                `$60`
              : result?.recommended_cars?.[0]?.displayTotalPrice ?? `$60`
          }/day at ${name}.`,
        },
      ]
    : [];
  return (
    <section id="rent80-serves-you" className="px-[13px]">
      <div className="max-w-7xl mx-auto mt-[22px] mb-[18px] lg:my-[60px]">
        <div className="space-y-[6px] lg:space-y-[10px] mb-[18px]">
          <h2 className="font-extrabold text-lg lg:text-[30px] text-my-dark-blue">
            {`Car rentals in ${name} in ${new Date().getFullYear()}`}
          </h2>
          <p className="space-y-6 text-sm font-normal text-my-light-blue lg:font-light lg:text-base">
            If you are wondering what rental car other users are booking, the
            data below will give you the insight. Below is the list of top-rated
            companies, most popular car groups, cheapest car model, and lowest
            rental price. All these are based on our user data and will help you
            make wise choices when renting a car.
          </p>
        </div>
        {isUserAgentBot ? (
          <table className="w-full">
            {servesData.map((data, index) => {
              return (
                <tr key={index}>
                  <th>{data.subtitle}</th>
                  <td>
                    {/* {data.link ? (
                      <a href={`${baseUrl}/${data.link}`}>{data.title}</a>
                    ) : (
                      <p>{data.title}</p>
                    )} */}
                    <p>{data.title}</p>
                  </td>
                </tr>
              );
            })}
          </table>
        ) : (
          <div className="md:grid grid-cols-2 lg:grid-cols-4 gap-6 rounded-[16px] md:rounded-none overflow-clip mt-[18px] lg:mt-10">
            {servesData.map((data) => {
              return (
                <ServesCard
                  key={data.id}
                  img={data.img}
                  subtitle={data.subtitle}
                  title={data.title}
                  desc={data.desc}
                  id={data.id}
                />
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default RentalFeatures;
